import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=fbca2fbc&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=ts&"
export * from "./Gallery.vue?vue&type=script&lang=ts&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=fbca2fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbca2fbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImageZoomer: require('/home/vsts/work/1/a/NuxtApp/components/base/ImageZoomer.vue').default,BaseVideo: require('/home/vsts/work/1/a/NuxtApp/components/base/Video.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,ProductDiscountLabels: require('/home/vsts/work/1/a/NuxtApp/components/product/DiscountLabels.vue').default,ProductLabel: require('/home/vsts/work/1/a/NuxtApp/components/product/Label.vue').default})
